import { paramCase } from "param-case"
import { decode } from "js-base64"

export default (info, metaData) => {
  // const testimonialArr = info.testimonials.map(testimonial => {
  //   return {
  //     "@type": "Review",
  //     author: {
  //       "@type": "Person",
  //       name: testimonial.name,
  //     },
  //     reviewBody: testimonial.content,
  //   }
  // })

  const galleryArr =
    info.gallery.length > 0
      ? info.gallery.map(imgObj => {
          const imgId = JSON.parse(
            decode(imgObj.image.asset.source.id)
          ).public_id

          return `https://res.cloudinary.com/agoraservices/${imgId}`
        })
      : null

  const hpImgArr =
    info.gallery.length > 0
      ? info.gallery.map(imgObj => {
          const imgId = JSON.parse(
            decode(imgObj.image.asset.source.id)
          ).public_id

          return `https://res.cloudinary.com/agoraservices/${imgId}`
        })
      : null

  const groundsImg = info.facilityInfo.facilityGroundsImage
    ? `https://res.cloudinary.com/agoraservices/${
        JSON.parse(
          decode(info.facilityInfo.facilityGroundsImage.asset.source.id)
        ).public_id
      }`
    : null

  const imgUrlArr = []

  groundsImg && imgUrlArr.push(groundsImg)

  galleryArr && galleryArr.forEach(galleryImg => imgUrlArr.push(galleryImg))

  hpImgArr && hpImgArr.forEach(hpImg => imgUrlArr.push(hpImg))

  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: info.facilityName,
    description: info.siteContent.initParagraph,
    logo: `https://res.cloudinary.com/agoraservices/${metaData.logoImgId}`,
    image:
      imgUrlArr.length > 1
        ? imgUrlArr
        : imgUrlArr.length === 1
        ? imgUrlArr[0]
        : null,
    "@id": paramCase(info.facilityName),
    url: metaData.siteUrl,
    telephone: info.facilityInfo.phone,
    email: info.facilityInfo.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: info.facilityInfo.streetAddress,
      addressLocality: info.facilityInfo.city,
      addressRegion: info.facilityInfo.state,
      postalCode: info.facilityInfo.zip,
      addressCountry: "US",
    },
    // review: testimonialArr,
  }
}
